export enum SeatConfigurationType {
  GENERAL_ADMISSION = 'GENERAL_ADMISSION',
  SEATED = 'SEATED',
}
